module.exports = __webpack_public_path__ + "static/media/thali.21cc1723.png";